import { Reducer } from 'redux';
import { EMPLOYEES_SET_MEMBERS, IStoreEmployees, IStoreEmployeesSetMembersAction } from './../employees';

export type IEmployeesActions = IStoreEmployeesSetMembersAction;

const initialState: IStoreEmployees = {
  filters: {
    groupId: null,
    memberId: null,
    showArchived: false,
  },
  members: [],
};

const employeesReducers: Reducer<IStoreEmployees, IEmployeesActions> = (state = initialState, action) => {
  switch (action.type) {
    case EMPLOYEES_SET_MEMBERS:
      return {
        ...state,
        members: action.payload.members,
      };
    default:
      return state;
  }
};

export default employeesReducers;
